"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var ErrorBoundary_1 = require("../ErrorBoundary");
var BlankSlate_1 = require("../BlankSlate");
require("./ListView.css");
var Spinner_1 = require("../Spinner");
var renderDefaultEmptyState = function () {
  return (0, jsx_runtime_1.jsx)(BlankSlate_1.BlankSlate, {});
};
var ListViewInner = function (_a) {
  var data = _a.data,
    indexer = _a.indexer,
    renderContent = _a.renderContent,
    renderHeader = _a.renderHeader,
    renderFooter = _a.renderFooter,
    _b = _a.isLoading,
    isLoading = _b === void 0 ? false : _b,
    _c = _a.separator,
    separator = _c === void 0 ? true : _c,
    onClick = _a.onClick,
    _d = _a.renderEmptyState,
    renderEmptyState = _d === void 0 ? renderDefaultEmptyState : _d,
    className = _a.className,
    itemStyle = _a.itemStyle,
    itemClass = _a.itemClass,
    restProps = __rest(_a, ["data", "indexer", "renderContent", "renderHeader", "renderFooter", "isLoading", "separator", "onClick", "renderEmptyState", "className", "itemStyle", "itemClass"]);
  var isDataEmpty = R.isNothing(data);
  var isClickable = !!onClick;
  var header = renderHeader && (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-list-view-header"
  }, {
    children: renderHeader()
  }));
  var spinner = (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-list-view-spinner-wrapper"
  }, {
    children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, {
      size: "extra-large"
    })
  }));
  var trueData = Array.isArray(data) ? data : data === undefined ? [] : [data];
  var listViewContent = (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-list-view", !separator && "no-separator")
  }, {
    children: trueData.map(function (item, index) {
      var itemIndex = indexer ? indexer(item) : index;
      return (0, jsx_runtime_1.jsx)("div", __assign({
        style: itemStyle,
        className: (0, classnames_1.default)("vsx-list-item", isClickable && "vsx-list-item-clickable", itemClass),
        onClick: onClick ? function () {
          return onClick(item);
        } : undefined
      }, {
        children: renderContent(item)
      }), itemIndex);
    })
  }));
  var footer = renderFooter && !isDataEmpty && (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-list-view-footer"
  }, {
    children: renderFooter()
  }));
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-list-view-container", className)
  }, {
    children: [header, isLoading && spinner, isDataEmpty && renderEmptyState(), !isDataEmpty && !isLoading && listViewContent, footer]
  }));
};
exports.ListView = (0, ErrorBoundary_1.withErrorBoundary)(ListViewInner);